module.exports = __webpack_public_path__ + "static/img/prc20172.43ff98f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programs/prc20172.jpg
// module id = /EmP
// module chunks = 1